/**
 * InfoDialog component displays game information in a modal dialog.
 * Uses FocusNavigationDialog base component for focus navigation integration.
 */
import * as React from "react"
import * as Dialog from "@radix-ui/react-dialog"
import { Button } from "@merels/ui"
import { FocusNavigationDialog } from "../../library/FocusNavigationDialog/FocusNavigationDialog"
import { gameControlsTestIds } from "./gameControls.testIds"

export interface InfoDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  gameName: string
  gameDescription?: string
  trigger: React.ReactElement
}

export const InfoDialog = React.forwardRef<HTMLButtonElement, InfoDialogProps>(
  ({ open, onOpenChange, gameName, gameDescription, trigger }, ref) => {
    return (
      <FocusNavigationDialog
        open={open}
        onOpenChange={onOpenChange}
        trigger={trigger}
        title={gameName}
        testId={gameControlsTestIds.infoDialog}
        ref={ref}
      >
        {gameDescription && (
          <p className="text-sm text-muted mb-4">
            {gameDescription}
          </p>
        )}
        <Dialog.Close asChild>
          <Button variant="outline" className="w-full">
            Close
          </Button>
        </Dialog.Close>
      </FocusNavigationDialog>
    )
  }
)
InfoDialog.displayName = "InfoDialog"
